module.exports = __webpack_public_path__ + "img/gallery-8.d146f0bd.webp";